import { UseGqlMutationCallbacks, useMutationOptionsWithInvalidation } from '@alice-financial/api'
import { useMutation } from '@tanstack/react-query'
import { useIntl } from 'react-intl'
import { useMutationNotifier } from '../../../../notifications/useMutationNotifier'
import {
  CreateWorkLocationAssignmentMutation,
  CreateWorkLocationAssignmentMutationVariables,
  useCreateWorkLocationAssignmentMutation,
} from './createWorkLocationAssignment_gen'

type UseCreateWorkLocationAssignmentOptions = UseGqlMutationCallbacks<
  CreateWorkLocationAssignmentMutation,
  Pick<CreateWorkLocationAssignmentMutationVariables, 'input'>
>

export const useCreateWorkLocationAssignment = (
  orgId: number,
  mutationOptions?: UseCreateWorkLocationAssignmentOptions
) => {
  const intl = useIntl()

  const _mutationOptions = useMutationNotifier(
    {
      onMutate: intl.formatMessage({ id: 'organization.work_locations.creating_assignment' }),
      onSuccess: intl.formatMessage({ id: 'organization.work_locations.assignment_created' }),
    },
    mutationOptions
  )

  // Import the organization query hook dynamically to avoid circular dependencies
  const invalidationKeys = [['OrgDashboard', { orgId }]]

  const mutationOptionsWithInvalidation = useMutationOptionsWithInvalidation(
    _mutationOptions,
    invalidationKeys
  )

  const { mutateAsync: createWorkLocationAssignment } = useCreateWorkLocationAssignmentMutation()

  return useMutation(
    ['createWorkLocationAssignment'],
    ({ input }) => createWorkLocationAssignment({ input }),
    mutationOptionsWithInvalidation
  )
}
